var $ = jQuery;
$(document).ready(function () {


$(document).on('click', '.color-custom.color-option', function(){
  var $swatch = $(this);
  var $card = $swatch.closest('.card');

  // 1) IMAGE
  var newImage = $swatch.attr('data-image');
  if (newImage) {
    $card.find('.media--hover-effect img').attr('src', newImage).attr('srcset', newImage);
  }

  // 2) PRICE & COMPARE
  var rawPrice = parseInt($swatch.attr('data-price'));
  var rawCompare = parseInt($swatch.attr('data-compare-price'));

  var priceNumber = rawPrice ? rawPrice / 100 : null;
  var compareNumber = rawCompare ? rawCompare / 100 : null;

  var formattedPrice = priceNumber !== null ? "€" + priceNumber.toLocaleString('de-DE', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) : null;
  var formattedCompare = compareNumber !== null ? "€" + compareNumber.toLocaleString('de-DE', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) : null;

  var onSale = compareNumber && priceNumber && compareNumber > priceNumber;

  // 3) RENDER PRICE
  var $priceWrapper = $card.closest('.card-wrapper').find('.price');
  if ($priceWrapper.length && formattedPrice) {
    if (onSale) {
      $priceWrapper.html(`
        <div class="price__container">
          <div class="price__sale">
            <span class="price-item price-item--regular"><s>${formattedCompare}</s></span>
            <span class="price-item price-item--sale price-item--last">${formattedPrice}</span>
          </div>
        </div>
      `);
    } else {
      $priceWrapper.html(`
        <div class="price__container">
          <div class="price__regular">
            <span class="price-item price-item--regular">${formattedPrice}</span>
          </div>
        </div>
      `);
    }
  }

  // 4) SALE BADGE %
  var $badge = $card.find('.card__badge .badge.on_sale');
  if (onSale) {
    var percent = Math.round((1 - priceNumber / compareNumber) * 100);
    $badge.text(`-${percent}%`).show();
  } else {
    $badge.hide();
  }

  // 5) ACTIVE CLASS
  $card.find('.color-custom.color-option').removeClass('selected');
  $swatch.addClass('selected');
});


var checkExist = setInterval(function() {
       var $targetInput = $('#bss-b2b-registration-form #password');
       if ($targetInput.length) {
          $targetInput.attr('placeholder', 'Passwort eingeben');
          clearInterval(checkExist);
       }
    }, 500);
  $(document).on('click', '.js-open-hundemantel-pro', function () {
  $('#hundemantel_pro_popup').fadeIn();
});

$(document).on('click', '#hundemantel_pro_popup *', function (e) {
  if (
    $(e.target).hasClass('hundemantel-popup__overlay') ||
    $(e.target).hasClass('hundemantel-popup__close')
  ) {
    $('#hundemantel_pro_popup').fadeOut();
  }
});


  // custom size 
  $('#dog-table tbody tr').hide(); 
  $(document).on('keyup', '#mein--hund', function() {
  var value = $(this).val().toLowerCase().trim();
  var matchedSize = '';

  $('#dog-table tbody tr').each(function() {
    var rasse = $(this).find('td:first').text().toLowerCase();
    var size = $(this).find('td:last').text().trim();

    if (rasse.indexOf(value) > -1 && value !== '') {
      $(this).show();
      matchedSize = size;
    } else if (value === '') {
      $(this).show();
    } else {
      $(this).hide();
    }
  });

  $('#grobe tbody tr').removeClass('active');

  if (matchedSize !== '') {
    $('#grobe tbody tr').each(function() {
      var sizeText = $(this).find('td:first').text().trim().toLowerCase();
      if (sizeText === matchedSize.toLowerCase()) {
        $(this).addClass('active');
      }
    });
  }
});

$(document).on('click', '#dog-table tbody tr', function() {
  var size = $(this).find('td:last').text().trim();
  $('#grobe tbody tr').removeClass('active');
  $('#grobe tbody tr').filter(function() {
    return $(this).find('td:first').text().trim() === size;
  }).addClass('active');
});

// custom size 


  //Start Slider mobile
  function initFlickityMobile() {
  var $lists = $("#faq--st .acc-tab-titles ul");

  if ($(window).width() < 950) {
    $lists.each(function () {
      if (!$(this).data('flickity')) {
        $(this).flickity({
          pageDots: true,
          freeScroll: false,
          wrapAround: false,
          prevNextButtons: false,
          autoPlay: 10000,
          groupCells: false,
          cellAlign: 'left'
        });
      }
    });
  } else {
    $lists.each(function () {
      if ($(this).data('flickity')) {
        $(this).flickity('destroy');
      }
    });
  }
}

$(document).ready(initFlickityMobile);
$(window).on('resize', initFlickityMobile);

  //End Slider mobile
  /*** MINI CART  ***/
   $(document).on("click", ".submit_form", function(e) {
      e.preventDefault(); 
      var $form = $(this).closest("form");
      var $select = $form.find("select[name='id']");
      var $selectedOption = $select.find("option:selected");
      var variantId = $selectedOption.val() || $(this).data("pro-id");
      var minQty = $selectedOption.data("min-qty") || 1;

      $.ajax({
        type: "POST",
        url: window.Shopify.routes.root + "cart/add.js",
        data: JSON.stringify({
          id: variantId,
          quantity: minQty
        }),
        dataType: "json",      
        contentType: "application/json",
        success: function(data) {
          var url = new URL(window.location.href);
          url.searchParams.set("open_cart_n", "2");
          window.location.href = url.toString();
        },
        error: function(xhr, status, error) {
          console.error("Add to cart error:", error);
        }
      });
    });
  /*** MINI CART  ***/ 
  /*** CUTOM RADIO  ***/
  function toggleGrid() {
    // let checked = $('.ub_subscription_box_group_selling_plan_select_opetion_radio input[type="radio"]:checked').val();
    let checked = $('.selling_plan_groups_custom  .utb_selected .ub_subscription_box_group_selling_plan_select_opetion_radio .ub_subscription_box_group_selling_text').text(); 
    // console.log("Radio checked:", checked); 
    if (checked == 'Einmallieferung') {
      if($('#tpl_new_grid_6').length>0){
        $('#tpl_new_grid_6').show();  
      }
    }else if (checked == 'Abo'){
      if($('#tpl_new_grid_6').length>0){
        $('#tpl_new_grid_6').hide();
      }  
    }else{
      if($('#tpl_new_grid_6').length>0){
        $('#tpl_new_grid_6').show();  
      }
    }
  }
  toggleGrid();
  $(document).on('change', '.ub_subscription_box_group_selling_plan_select_opetion_radio input[type="radio"]', function() {
    toggleGrid();
  });
  var observer = new MutationObserver(function() {
    toggleGrid();
  });

  observer.observe(document.body, { childList: true, subtree: true }); 
  /*** CUTOM RADIO  ***/

   const params = new URLSearchParams(window.location.search);
  if (params.get('open_cart') === '1') {
    document.querySelector('.header__icon--cart')?.click();
    params.delete('open_cart');
    history.replaceState({}, '', `${location.pathname}?${params}`);
  }
  
  $(document).on("mouseenter", ".utterbond-cart-form", function() {
    $(".infromation__bubble").addClass("showing");
  }).on("mouseleave", ".utterbond-cart-form", function() {
      $(".infromation__bubble").removeClass("showing");
  });

$(document).on('click', '.dn-subscribe-btn', function() {
    const sellingPlanId = $(this).prev().closest("fieldset").find('select').val();
    const variantId = $(this).prev().closest("fieldset").find('select').attr('data-variant-id')
          
          let formData = {
            'items': [{
              'id': variantId,
              'quantity': 1,
              'selling_plan': sellingPlanId,
            }]
          }
          fetch('/cart/add.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json'
            },
            body: JSON.stringify(formData)
          })
          .then(response => {
            return response.json();
          })
          .then(data=> window.location.href="/cart")
          .catch((error) => {
            //console.error('Error:', error);
          });
  })
        

  
    function formatMoney(cents) {
      return (cents / 100).toLocaleString('de-DE') + '€\u00A0';
    }

      $(document).on('change', '.select__select', function () {
        var $select = $(this);
        var $productItem = $select.closest('.pdp_detail');

        var selectedOptions = [];

        $productItem.find('.select__select').each(function () {
          selectedOptions.push($(this).val());
        });

     var variantsData = $productItem.attr('data-variants');
      if (!variantsData) {
        return;
      }

      var matchedVariant = variants.find(function (variant) {
        return variant.options.every(function (opt, index) {
          return opt === selectedOptions[index];
        });
      });

      if (matchedVariant) {
        var $priceContainer = $productItem.find('.price-custom');
        var priceHtml = '';

        if (matchedVariant.compare_at_price > matchedVariant.price) {
          priceHtml += '<span class="sale-price">' + formatMoney(matchedVariant.price) + '</span>';
          priceHtml += '<span class="original-price">' + formatMoney(matchedVariant.compare_at_price) + '</span>';
          priceHtml += '<span class="du-sparst">Du sparst ' + formatMoney(matchedVariant.compare_at_price - matchedVariant.price) + '</span>';
        } else {
          priceHtml += '<span class="regular-price">' + formatMoney(matchedVariant.price) + '</span>';
        }

        $priceContainer.html(priceHtml);

        $productItem.find('.product-variant-id').val(matchedVariant.id);
        var $btn = $productItem.find('button[type="submit"]');
        if (matchedVariant.available) {
          $btn.prop('disabled', false);
        } else {
          $btn.prop('disabled', true);
        }
      }
  
});

  
  $(document).ready(() => {
  const $searchInput = $("#faq-search");
  const $accordions = $(".acc");
  const $containers = $(".acc-container");
  const $noResults = $("<div>", {
    class: "no-results-message",
    text: "Keine Ergebnisse gefunden.",
    css: { display: "none" }
  }).appendTo(".acc-tab-content");

  $searchInput.on("input", () => {
    const query = $searchInput.val().trim().toLowerCase();
    let hasMatches = false;

    // Show all tabs during search
    $(".tabs-content").show();

    $accordions.each(function () {
      const $acc = $(this);
      const title = $acc.find(".acc-head p span:first-child").text().toLowerCase();
      const content = $acc.find(".acc-content").text().toLowerCase();
      const isMatch = query === "" || title.includes(query) || content.includes(query);

      $acc.toggle(isMatch);
      if (isMatch) {
        hasMatches = true;
        $acc.closest(".tabs-content").show();
      }
    });

    // Adjust container visibility and remove padding-bottom during search
    $containers.each(function () {
      const $container = $(this);
      if ($container.find(".acc:visible").length === 0) {
        $container.hide();
      } else {
        $container.show();
      }
      $container.css("padding-bottom", query === "" ? "" : "0"); // Restore padding when query is empty
    });
    $(".acc-load-more-wrapper").toggle(query === "");

    // Show/hide no results message
    $noResults.toggle(!hasMatches && query !== "");
  });
});
  
  $('.footer-block.has-dropdown .footer-block__heading').click(function (e) { 
      e.preventDefault();
      $(this).toggleClass('active');
  });
  //  $('.box-size').click(function (e) { 
  //       e.preventDefault();
  //       $('#custom-tab').addClass('active');
  //   });
  $(document).on('click', '.box-size', function (e) {
    e.preventDefault();
    $('#custom-tab').addClass('active');
  });

    $('.close-tabs').click(function (e) { 
        e.preventDefault();
        $('#custom-tab').removeClass('active');
    });
  $('.has_slider').flickity({
    freeScroll: false,
    wrapAround: true,
    groupCells: true,
    prevNextButtons: true,
    pageDots: true,
    cellAlign: 'left'
  });
  $('.product-media-gallery').flickity({
    freeScroll: true,
    wrapAround: true,
    groupCells: true,
    prevNextButtons: true,
    pageDots: true,
    cellAlign: 'left'
  });
  $('.has_slider_blogs').flickity({
    freeScroll: true,
    wrapAround: true,
    groupCells: true,
    prevNextButtons: true,
    pageDots: true,
    cellAlign: 'left'
  });
  
  let flickityInstance = null;

  function initFlickity() {
    const $slider = $('.b2b-audience-groups');
  
    if ($slider.length > 0) {
      if (window.innerWidth < 990) {
        if (!flickityInstance) {
          flickityInstance = $slider.flickity({
            freeScroll: false,
            wrapAround: true,
            groupCells: true,
            prevNextButtons: false,
            pageDots: true,
            cellAlign: 'center'
          });
        }
      } else {
        if (flickityInstance) {
          flickityInstance.flickity('destroy');
          flickityInstance = null;
        }
      }
    }
  }
  initFlickity();
  
  // $('.product-single__gallery').flickity({
  //     imagesLoaded: true,
  //     groupCells: false,
  //     dragThreshold: 5,
  //     cellAlign: 'left',
  //     wrapAround: true,
  //     prevNextButtons: true,
  //     percentPosition: true, 
  //     pageDots: false,
  //     rightToLeft: false,
  //     // asNavFor: '.product-single__thumbnails',
  //     autoPlay: false
  // }); 
  // $('.product-single__thumbnails').flickity({
  //     contain: true,
  //     pageDots: false,
  //     prevNextButtons: false, 
  //     autoPlay: false,
  //     cellAlign: 'left',
  //     asNavFor: '.product-single__gallery'
  // }); 
  // $('.product-single__gallery').on('change.flickity', function(event, index) {
  //     var $thumbnails = $('.product-single__thumbnails li');
  //     $thumbnails.removeClass('active');  // Remove 'active' class from all thumbnails
  //     $thumbnails.eq(index).addClass('active');  // Add 'active' class to the current thumbnail
  // });
  // $('.product-single__thumbnails li').first().addClass('active');
  
  // // Thumbnail click event to change the gallery image
  // $('.product-single__thumbnails li').on('click', function() {
  //     var index = $(this).index();
  //     $('.product-single__gallery').flickity('select', index);  // Select the corresponding image in the gallery
  // });
  ///// Tab Faq
  $(document).on('click','.acctab_title', function(e){
     if($(window).width() >= 768){
        $('.acctab_title').removeClass('active-accor');
        $(this).addClass('active-accor');
        $('.acc_tab-inner .acc-tab-content .tabs-content').removeClass('activemain-tab').hide();
        $($(this).attr('data-act-title')).addClass('activemain-tab').show();
     }else{
       $('.acctab_title').removeClass('active-accor');
        $(this).addClass('active-accor');
        $('.acc_tab-inner .acc-tab-content .tabs-content').removeClass('activemain-tab').hide();
        $($(this).attr('data-act-title')).addClass('activemain-tab').show();
        // $('.acc_tab-inner .acc-tab-content .tabs-content').removeClass('activemain-tab').hide();
        $('.acc_tab-inner .acc-tab-content').addClass('tab-content-show').show();
        $($(this).attr('data-act-title')).addClass('activemain-tab').show();
     }
  });
  $(document).on('click','.acc_tab-inner .acc-tab-content .back__arrow', function(e){
      $('.acc_tab-inner .acc-tab-content').removeClass('tab-content-show').show();
  });
  $('.acc-head').on('click', function() {
      if($(this).hasClass('active')) {
        $(this).siblings('.acc-content').slideUp();
        $(this).removeClass('active');
      }
      else {
        $('.acc-content').slideUp();
        $('.acc-head').removeClass('active');
        $(this).siblings('.acc-content').slideToggle();
        $(this).toggleClass('active');
      }
  });
  $(".acc-load-more").on("click", function() {
    const $container = $(this).closest(".acc-container");
    const $hiddenItems = $container.find(".hidden-acc");
    $hiddenItems.each(function() {
      $(this).removeClass("hidden-acc").css("display", "block");
    });
    $(this).parent().css("display", "none");
  });
  // var swiper = new Swiper('.slider-upsell', {
  //   slidesPerView: 1,
  //   spaceBetween:10,
  //   loop: true,
  //   centeredSlides: true,
  //   autoplay: {
  //     delay: 50000,
  //     disableOnInteraction: false,
  //   },
  //    navigation: {
  //     nextEl: '.upsell_products .swiper-button-next',
  //     prevEl: '.upsell_products .swiper-button-prev',
  //   }
  // });
   function setEqualHeight() {
    var maxHeight = 0;
    $('.collection .card__heading').css('height', 'auto');

    $('.collection .card__heading').each(function() {
        var currentHeight = $(this).outerHeight();
        if (currentHeight > maxHeight) {
            maxHeight = currentHeight;
        }
    });

    $('.collection .card__heading').each(function() {
        $(this).css('height', maxHeight + 'px');
    });
  }

  $(document).ready(function() {
      setEqualHeight();
  });
  
  $(window).on('resize', function() {
      setEqualHeight();
     initFlickity();
  });

  $('.togglePassword').on('click', function () {
    const $passwordInput = $(this).siblings('input');
    const type = $passwordInput.attr('type') === 'password' ? 'text' : 'password';
    $passwordInput.attr('type', type);
  });
  $(document).on('change', '.th_subscription_section .th_subscription_fieldset', function() {
    $('.utterbond-cart-form').removeClass('change');
  });
  $(document).on('change', '.th_subscription_section .th_subscription_fieldset:nth-child(2)', function() {
    $('.utterbond-cart-form').addClass('change');
  });
  
});




const params = new URLSearchParams(window.location.search);
if (params.get('open_cart_n') === '2') {
   const cartToggle = document.querySelector('#cart-icon-bubble');
    if (cartToggle) {
      cartToggle.click();
  }
  params.delete('open_cart_n');
  history.replaceState({}, '', `${location.pathname}?${params}`);
}


const scriptTag = $('script[data-selected-variant]').first();  
  if (scriptTag.length) {
    console.log(scriptTag);
      const jsonData = JSON.parse(scriptTag.text().trim());
      const featuredMediaId = jsonData.featured_media?.id;  
      const sectionIdValue = $('input[name="section-id"]').val();
      const mediaId = `${sectionIdValue}-${featuredMediaId}`;
    
   setTimeout(() => {
    var $thumb = $(`li[data-att="${mediaId}"]`);
    console.log('FOUND?', $thumb.length, mediaId);
    if ($thumb.length) $thumb.trigger('click');
  }, 500);
  }
